"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IPinfo = (function () {
    function IPinfo(data, countries) {
        this._ip = data.ip;
        this._hostname = data.hostname;
        this._city = data.city;
        this._region = data.region;
        this._country = countries[data.country];
        this._countryCode = data.country;
        this._loc = data.loc;
        this._postal = data.postal;
        this._carrier = data.carrier;
        this._asn = data.asn;
        this._company = data.company;
        this._phone = data.phone;
    }
    Object.defineProperty(IPinfo.prototype, "ip", {
        get: function () {
            return this._ip;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IPinfo.prototype, "hostname", {
        get: function () {
            return this._hostname;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IPinfo.prototype, "city", {
        get: function () {
            return this._city;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IPinfo.prototype, "region", {
        get: function () {
            return this._region;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IPinfo.prototype, "country", {
        get: function () {
            return this._country;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IPinfo.prototype, "countryCode", {
        get: function () {
            return this._countryCode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IPinfo.prototype, "loc", {
        get: function () {
            return this._loc;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IPinfo.prototype, "postal", {
        get: function () {
            return this._postal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IPinfo.prototype, "carrier", {
        get: function () {
            return this._carrier;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IPinfo.prototype, "asn", {
        get: function () {
            return this._asn;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IPinfo.prototype, "company", {
        get: function () {
            return this._company;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IPinfo.prototype, "phone", {
        get: function () {
            return this._phone;
        },
        enumerable: true,
        configurable: true
    });
    IPinfo.Fqdn = "http://ipinfo.io/";
    IPinfo.FqdnSSL = "https://ipinfo.io/";
    return IPinfo;
}());
exports.default = IPinfo;
